export const CHART_CATEGORICAL_PALETTE = [
  "var(--brand-600)",
  "var(--rd-success-500)",
  "var(--rd-warning-500)",
  "var(--rd-danger-500)",
  "var(--rd-info-500)",
  "var(--chart-cat-6)",
  "var(--text-tertiary)",
] as const;

export type ChartCategoricalIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export function chartCategorical(index: number): string {
  const palette = CHART_CATEGORICAL_PALETTE;
  const safeIndex = ((index % palette.length) + palette.length) % palette.length;
  return palette[safeIndex]!;
}
